import React from "react";
import {CustomButton} from "ui";
import GenericError from "views/AccessError/GenericError";

type ErrorBoundaryProps = {
  children: React.ReactNode;
  goBack?: () => void;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {hasError: false};
  }

  static getDerivedStateFromError(error: Error) {
    console.error("error", error);
    return {hasError: true};
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  resetError = () => {
    this.setState({hasError: false});
  };

  render() {
    if (this.state.hasError) {
      return (
        <GenericError
          customButton={
            <CustomButton
              startIcon="arrow_back"
              size="small"
              onClickFn={() => {
                this.props.goBack?.();
                this.resetError();
              }}
            >
              Voltar
            </CustomButton>
          }
        />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
